import Flex from 'typescript-styled-flex'
import styled, { ITheme } from '../../theme'
import { IWithSize } from '../../containers/BookingCalendar/Calendar/Calendar'

const ButtonWrapper = styled(Flex as any)<IWithSize>`
  width: 100%;
  height: ${({ size }) => (size ? 120 * size : 120)}px;
  justify-content: center;

  @media (max-width: 1275px) {
    width: unset;
    position: absolute;
    justify-content: end;
    right: 62px;
  }

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    right: 35px;
    height: ${({ size }) => (size ? 80 * size : 80)}px;
    position: sticky;
  }
`

export default ButtonWrapper
